function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.954 8h4.742c.386 0 .733-.157.882-.515a.9.9 0 0 0-.207-1.003l-4.743-4.715A.954.954 0 0 0 17 2.444v4.75c0 .53.428.806.954.806z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.046 10h-7.124C15.86 10 15 9.29 15 8.23V1.103C15 .577 14.572 0 14.046 0H2.966C1.327 0 0 1.478 0 3.114v26.07C0 30.825 1.328 32 2.965 32h19.07C23.672 32 25 30.823 25 29.186V11.104c0-.527-.428-1.104-.954-1.104zM12.5 25.684s-5.814-2.582-5.814-7.293a3.027 3.027 0 0 1 5.814-1.187 3.028 3.028 0 0 1 5.814 1.188c0 4.71-5.814 7.293-5.814 7.293z"
});

var SvgFileLiked = function SvgFileLiked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileLiked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-liked.205423c8.svg";
export { ForwardRef as ReactComponent };